import React from 'react'
import "./Common_heading.css"

function Common_heading({ headingText }) {
    return (
        <section className="Common_heading">
            <h1 className='heading'>{headingText}</h1>
        </section>
    )
}

export default Common_heading